// extracted by mini-css-extract-plugin
module.exports = {"text":"Intro_text__M5D2Y","textWrapper":"Intro_textWrapper__1Z152","textContainer":"Intro_textContainer__IWMGP","intro":"Intro_intro__R68Dn","scale":"Intro_scale__bj1fz"};